import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { FormGroup, FormControl, ControlLabel/*, HelpBlock*/, Col, Clearfix } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { actionCreators } from '../../store/Login';

class Login extends Component {
    displayName = Login.name;
    constructor(props) {
        super(props);

        this.state = {
            redirectToForgotPassword: false
        };
    }

    onSubmit = (e) => {
        e.preventDefault();
        let username = document.getElementsByName('username')[0].value;
        let password = document.getElementsByName('password')[0].value;
        this.props.requestLoginToken(username, password);
    }

    onClickForgotPassword = (e) => {
        e.preventDefault();
        this.setState({ redirectToForgotPassword: true });
    }

    render() {
        if (this.props.isAuthenticated) {
            return (
                <Redirect to="/" />
            );
        }
        else if (this.state.redirectToForgotPassword) {
            return (
                <Redirect to="/ForgotPassword" />
            );
        }
        else {
            return (
                <div>
                    <Col xs={10} xsOffset={1} sm={8} smOffset={2} md={6} mdOffset={3} lg={6} lgOffset={3} >
                        <div style={{ paddingBottom: '25px' }}>
                            <h4 className="text-center"><strong>Welcome to</strong> <span className="ogcText">OGC Customer Portal</span></h4>
                            <h5 className="text-center">Please log in to get started</h5>

                            <form onSubmit={this.onSubmit} style={{ maxWidth: '25em', margin: 'auto' }}>
                                <FormGroup controlId="formControlsUsername">
                                    <ControlLabel>User Name</ControlLabel>
                                    <FormControl componentClass="input" type="text" name="username" placeholder="User Name" />
                                </FormGroup>
                                <FormGroup controlId="formControlsPassword">
                                    <ControlLabel>Password</ControlLabel>
                                    <FormControl componentClass="input" type="password" name="password" placeholder="Password" />
                                    <div>
                                        <label style={{ paddingTop: '8px', fontSize: '11px' }} className="pull-right">
                                            <Link to="blah" onClick={this.onClickForgotPassword}>Forgot Password?</Link>
                                        </label>
                                    </div>
                                </FormGroup>
                                <Clearfix />
                                <br />
                                <FormGroup className="text-center">
                                    <button className="btn-block ogcButton" type="submit" style={{ margin: '0' }} >SIGN IN</button>
                                </FormGroup>

                                {/*this.props.authFailed &&
                            <HelpBlock style={{ color: 'red' }}>Invalid user name or password.</HelpBlock>
                        */}
                            </form>
                        </div>
                    </Col>
                </div>
            );
        }
    }
}

export default connect(
    state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Login);




// WEBPACK FOOTER //
// ./src/components/Login/Login.js